const Constants = {
  InputCharacterLimit: 250,
};

export default Constants;
